import { useEffect, useState } from 'react'

declare global {
  interface Window {
    flutterApp: any
    flutterMessage?: (
      deviceName: string,
      deviceOsVersion: string,
      deviceConnectivity: string
    ) => void
  }
}

type UseWebViewModeProps = {
  title?: string
}

export const useWebViewMode = ({ title }: UseWebViewModeProps) => {
  const [isWebViewMode, setIsWebViewMode] = useState<boolean>()

  useEffect(() => {
    if (window.flutterApp && window.flutterApp.postMessage) {
      setIsWebViewMode(true)
      if (title) {
        window.flutterApp.postMessage(title)
      }
    } else if (window.flutterApp && !window.flutterApp.postMessage) {
      setIsWebViewMode(true)
    } else if (process.env.NEXT_PUBLIC_WEBVIEW_DEBUG === 'true') {
      setIsWebViewMode(true)
    } else {
      setIsWebViewMode(false)
    }
  }, [title])

  return isWebViewMode
}
